import { GetFileLayout } from "../../data-kinds";

export type GetIFDefinitionsResponse = {
  /**
   * The results of this get_if_definitions response body.
   */
  total: number;
  hitCount: number;
  ifList: GetIfList[];
  fileLayoutList?: GetFileLayout[];
};
export type GetIfList = {
  updateDateTime: string;
  project: Project;
  projectTcktInfo: ProjectTcktInfo;
  src: Src;
  dst: Dst;
  information: Information;
};
export type Project = {
  ifReqCnclTypeCd: string;
  ifReqId: string;
  pjtId: string;
  pjtName: string;
  stgDplymntPlnDate?: string;
  prdDplymntPlnDate?: string;
  dtKindIdIssueNumGrpCd?: string;
  exgInbdId?: string;
  exgIntdmnId?: string;
  exgOtbdId?: string;
  mltcstDsbldFlg?: string;
  dplymntGrpTag?: string;
};
export type ProjectTcktInfo = {
  srcDsgnTcktId: string;
  srcDsgnTcktStsTypeCd: string;
  srcDsgnWFlwStsDsplyName: string;
  srcDsgnCmnt: string;
  srcDsgnTcktUpdateDateTime: string;
  dstDsgnTcktId: string;
  dstDsgnTcktStsTypeCd: string;
  dstDsgnWFlwStsDsplyName: string;
  dstDsgnCmnt: string;
  dstDsgnTcktUpdateDateTime: string;
  srcStgDplymntTcktId: string;
  srcStgDplymntTcktStsTypeCd: string;
  srcStgDplymntWFlwStsDsplyName: string;
  dstStgDplymntTcktId: string;
  dstStgDplymntTcktStsTypeCd: string;
  dstStgDplymntWFlwStsDsplyName: string;
  srcPrdDplymntTcktId: string;
  srcPrdDplymntTcktStsTypeCd: string;
  srcPrdDplymntWFlwStsDsplyName: string;
  dstPrdDplymntTcktId: string;
  dstPrdDplymntTcktStsTypeCd: string;
  dstPrdDplymntWFlwStsDsplyName: string;
};
export type Src = {
  interfaceDefinition: InterfaceDefinition;
};
export type Dst = {
  interfaceDefinition: InterfaceDefinition;
};
export type InterfaceDefinition = {
  interfaceRequirementType?: string;
  metaOnlyFlag?: string;
  interfaceId?: string;
  interfaceNameEnglish?: string;
  interfaceNameJapanese?: string;
  dataKindId?: string;
  dipByRegion?: string;
  inbound?: Inbound;
  outbound?: Outbound;
};
export type Information = {
  duplicatedIdList: DuplicatedIdInfo[];
  layoutFileExistanceList?: LayoutFileExists[];
};

export type DuplicatedIdInfo = {
  message: string[];
  srcDstType: string;
  ifItmGrpPhysclName: string;
  ifItmPhysclName: string;
  value: string;
  duplicateInProject: boolean;
  duplicateDeployed: boolean;
  latestDeployerProjectId: string;
  duplicatedProjectList: DuplicatedProject[];
};

export type LayoutFileExists = {
  fileId: string;
  exists: boolean;
  message: string;
};

export type DuplicatedProject = {
  pjtId: string;
  pjtName: string;
};

export type Inbound = {
  inboundId?: string;
  inboundIdOptionalPart?: string;
  componentId?: string;
  protocol?: string;
  securityInformationLevel?: string;
  talendProject?: string;
  etlJobOptionsStg?: string;
  etlJobOptionsPrd?: string;
  interruptType?: string;
  useEtlTransceiver?: string;
  useConverter?: string;
  baseFileId?: string;
  inboundNotification?: InboundNotification;
  inboundTransceiver?: InboundTransceiver;
  inboundConverter?: InboundConverter;
  inboundPartner?: InboundPartner;
  inboundMeta?: InboundMeta;
  inboundSecurity?: InboundSecurity;
};
export type Outbound = {
  outboundId?: string;
  outboundIdOptionalPart?: string;
  componentId?: string;
  protocol?: string;
  outputFilePrefixStg?: string;
  outputFilePrefix?: string;
  outputFileBodyStg?: string;
  outputFileBody?: string;
  fileExtension?: string;
  autoPendingFlag?: string;
  sendDatalakeType?: string;
  talendProject?: string;
  etlJobOptionsStg?: string;
  etlJobOptionsPrd?: string;
  interruptType?: string;
  overwriteFlag?: string;
  autoRetryFlg?: string;
  useEtlTransceiver?: string;
  useConverter?: string;
  outboundNotification?: OutboundNotification;
  outboundTransceiver?: OutboundTransceiver;
  outboundConverter?: OutboundConverter;
  outboundPartner?: OutboundPartner;
  outboundMeta?: OutboundMeta;
  outboundSecurity?: OutboundSecurity;
};
export type InboundNotification = {
  notificationType?: string;
  notifyFlag?: string;
  notificationPfId?: string;
  notificationConfig?: string;
  sshNotificatonConfig?: string;
  kafkaNotificationConfig?: string;
};
export type OutboundNotification = {
  notificationType?: string;
  notifyFlag?: string;
  notificationPfId?: string;
  notificationConfig?: string;
  sshNotificatonConfig?: string;
  kafkaNotificationConfig?: string;
};
export type InboundTransceiver = {
  jobType?: string;
  jobName?: string;
  minHeap?: string;
  maxHeap?: string;
  talendJobVersion?: string;
  concurrentFlag?: string;
  bqDatasetIdStg?: string;
  bqDatasetIdPrd?: string;
};
export type OutboundTransceiver = {
  jobType?: string;
  jobName?: string;
  minHeap?: string;
  maxHeap?: string;
  talendJobVersion?: string;
  concurrentFlag?: string;
  bqDatasetId?: string;
};
export type InboundConverter = {
  jobType?: string;
  jobName?: string;
  minHeap?: string;
  maxHeap?: string;
  talendJobVersion?: string;
  differentLayoutsForInputAndOutput?: string;
};
export type OutboundConverter = {
  jobType?: string;
  jobName?: string;
  minHeap?: string;
  maxHeap?: string;
  talendJobVersion?: string;
  differentLayoutsForInputAndOutput?: string;
};
export type InboundPartner = {
  partnerIfId?: string;
  partnerCode?: string;
  partnerName?: string;
  partnerType?: string;
  partnerBusiness?: string;
  chainTypeCode?: string;
  fileTypeCode?: string;
  pollingAdaptorTypeCode?: string;
  permitNoFile?: string;
  partnerAddressStg?: string;
  partnerAddressPrd?: string;
  partnerInitFlg?: string;
  remoteFileId?: string;
  receiveFlag?: string;
};
export type OutboundPartner = {
  partnerIfId?: string;
  partnerCode?: string;
  partnerName?: string;
  partnerType?: string;
  partnerBusiness?: string;
  chainTypeCode?: string;
  fileTypeCode?: string;
  includeDtd?: string;
  partnerAddressStg?: string;
  partnerAddressPrd?: string;
  partnerInitFlg?: string;
  remoteFileId?: string;
  sendFlg?: string;
};
export type InboundMeta = {
  ifCycle?: string;
  ifCycleNote?: string;
  snapshotIncrementalDelta?: string;
  interfaceStartMethod?: string;
  numberOfFilesPerASendProcess?: string;
  densityOfNumberOfFilesPerAMinute?: string;
  dataScopePerInterfaceId?: string;
  dataScopePerInterfaceIdNote?: string;
  dataScopePerInterfaceFile?: string;
  dataScopePerInterfaceFileNote?: string;
  fileId?: string;
  tableId?: string;
};
export type OutboundMeta = {
  dataScopePerInterfaceId?: string;
  dataScopePerInterfaceIdNote?: string;
  dataScopePerInterfaceFile?: string;
  dataScopePerInterfaceFileNote?: string;
  fileId?: string;
  tableId?: string;
};
export type InboundSecurity = {
  contentsAccessibleFlag?: string;
  workFileRetentionDays?: string;
  encryptionTypeKey?: string;
  encryptionTypeValue?: string;
  dataSubjectKey?: string;
  dataSubjectValue?: string;
  retentionPeriodKey?: string;
  retentionPeriodValue?: string;
  piidb?: Piidb;
  slk?: Slk;
  dlk?: Dlk;
};
export type OutboundSecurity = {
  encryptionTypeKey?: string;
  encryptionTypeValue?: string;
  securityInformationTransferFlagKey?: string;
  securityInformationTransferFlagValue?: string;
};
export type Piidb = {
  nameKey?: string;
  nameValue?: string;
  addressKey?: string;
  addressValue?: string;
  phoneKey?: string;
  phoneValue?: string;
  emailKey?: string;
  emailValue?: string;
  governmentIssuedIdKey?: string;
  governmentIssuedIdValue?: string;
  bankAccountInfoKey?: string;
  bankAccountInfoValue?: string;
  paymentCardInfoKey?: string;
  paymentCardInfoValue?: string;
  healthInfoKey?: string;
  healthInfoValue?: string;
  otherKey?: string;
  otherValue?: string;
};
export type Slk = {
  postcodeKey?: string;
  postcodeValue?: string;
  genderKey?: string;
  genderValue?: string;
  dateOfBirthKey?: string;
  dateOfBirthValue?: string;
  membershipIdEtcKey?: string;
  membershipIdEtcValue?: string;
  employeeIdKey?: string;
  employeeIdValue?: string;
  orderInfoKey?: string;
  orderInfoValue?: string;
  purchaseInfoKey?: string;
  purchaseInfoValue?: string;
  deviceInfoKey?: string;
  deviceInfoValue?: string;
  geoLocationKey?: string;
  geoLocationValue?: string;
  sizeInfoKey?: string;
  sizeInfoValue?: string;
};
export type Dlk = {
  systemInfoKey?: string;
  systemInfoVal?: string;
  ipAddressKey?: string;
  ipAddressVal?: string;
};
